import { Card, Text, SimpleGrid, Input, Stack, Textarea } from '@mantine/core';
import { useClientIPPFormContext } from '../ClientIppSection';

export const ClientStatusCard: React.FC = () => {
  const form = useClientIPPFormContext();

  return (
    <Card shadow="sm" radius="md" withBorder>
      <Text fw={700} size="lg">
        Aktuální stav
      </Text>
      <SimpleGrid verticalSpacing="sm" cols={2}>
        <Stack>
          <Input.Wrapper label="Pohyblivost">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              data-testid="mobility-input"
              {...form.getInputProps(`mobility`)}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Poznámka ke zdravotnímu stavu klienta">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              minRows={2}
              data-testid="healthDesc-input"
              {...form.getInputProps(`healthDesc`)}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Zaměření péče">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              minRows={4}
              data-testid="reqCare-input"
              {...form.getInputProps(`reqCare`)}
            />
          </Input.Wrapper>
        </Stack>
        <Stack>
          <Input.Wrapper label="Osobní cíl nebo cíle">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              data-testid="goal-input"
              {...form.getInputProps(`goal`)}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Popis situace">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              data-testid="sitDesc-input"
              {...form.getInputProps(`sitDesc`)}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Vlastní zdroje klienta">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              data-testid="clientRes-input"
              {...form.getInputProps(`clientRes`)}
            />
          </Input.Wrapper>
          <Input.Wrapper label="Rizika">
            <Textarea
              variant="filled"
              radius="md"
              placeholder="note"
              autosize
              data-testid="risks-input"
              {...form.getInputProps(`risks`)}
            />
          </Input.Wrapper>
        </Stack>
      </SimpleGrid>
    </Card>
  );
};
